import {
  Component,
  computed,
  ContentChild,
  EventEmitter,
  inject,
  input,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  TemplateRef
} from '@angular/core';

import {map, Observable, Subscription} from 'rxjs';

import {Sort} from '@angular/material/sort';
import {SettingsService} from '../../../../services/settings.service';
import {SelectionModel} from '@angular/cdk/collections';
import {IndexedDBTableName, TableColumn, TableColumnType} from '../../../interfaces/table.interface';
import {
  PageableParam,
  SearchCombinationTypeEnum,
  SearchFieldsDtoInput,
  SearchOperationType
} from '../../../interfaces/data.interfaces';
import {NotificationService} from '../../../../services/notification.service';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {Clipboard} from '@angular/cdk/clipboard';
import { GraphqlService } from 'src/app/services/graphql.service';

@Component({
    selector: 'app-table-pageable',
    templateUrl: './table-pageable.component.html',
    styleUrls: ['./table-pageable.component.scss'],
    standalone: false
})
export class TablePageableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() tableColumns: TableColumn[];
  @Input() currentPage = 0;
  @Input() pageSize = 10;
  @Input() tableCssClass: string[];
  @Input() tableData$: Observable<any>;
  @Input() pageSizeOptions: number[] = [10, 50, 100, 250];
  @Input() searchFields: SearchFieldsDtoInput[];
  @Input() isPageable = true;
  gqlQuery = input();
  useQuery = input(false);

  searchDataDto = computed(()=>{

  })

  cacheTableColumns: TableColumn[];
  cacheSearchFields: SearchFieldsDtoInput[] = null;
  cacheAdvanceSearchFields: SearchFieldsDtoInput[] = [];
  cacheSearchCombinationType: SearchCombinationTypeEnum = SearchCombinationTypeEnum.Or;
  cacheTableData: any;
  cacheAdvanceSearchIndexedKey: number = null;

  @Output() tableColumnSelection = new EventEmitter<TableColumn[]>();

  @ContentChild(TemplateRef, {static: true}) actions: TemplateRef<any>;

  tableColumnType = TableColumnType;
  @Output() totalElementsAndPages = new EventEmitter<{ totalElements: number, totalPages: number }>();
  cacheTotalElements: number;
  @Output() pageable = new EventEmitter<PageableParam>();
  @Output() selectionChange = new EventEmitter<any>();
  subscriptions: Subscription = new Subscription();
  selection = new SelectionModel<any>(true, []);

  totalPages = 1;
  pagination = [];
  sortKey: string;
  sortDirectionKey: string;
  searchKey: string;

  protected readonly SearchOperationType = SearchOperationType;
  protected readonly SearchCombinationTypeEnum = SearchCombinationTypeEnum;

  dbService = inject(NgxIndexedDBService);
  settingsService = inject(SettingsService);
  notificationService = inject(NotificationService);
  clipboard = inject(Clipboard);
  apollo = inject(GraphqlService);
  // excelReaderService = inject(ExcelReaderService);

  constructor() {}

  ngOnInit(): void {
    this.cacheTableColumns = this.tableColumns;



    if(this.useQuery()){
      this.tableData$ = this.apollo.getDataFromApi(
        this.gqlQuery(),  {
        searchDataDto: {
          pageable: {
            pageNumber: 0,
            pageSize: 10,
          },
          searchCombinationType: SearchCombinationTypeEnum.Or,
          searchFields: []
        },
        active: true
        }
      ).pipe(
        map(data=>{
          console.log({data});
          
          return data.content
        })
      )
    }
else
    this.subscriptions.add(
      this.tableData$?.subscribe( (tableData) => {
        if (tableData){
          this.cacheTableData = tableData;
        }
      })
    );

    this.subscriptions.add(
      this.selection?.changed.subscribe( (selectedRow) => {
        if (selectedRow){
          this.selectionChange.emit(this.selection.selected);
        }
      })
    );

    /*get advance search data from indexedDB*/
    // this.dbService.getByIndex(IndexedDBTableName.advance_table_search, 'route', window.location.pathname)
    //   .toPromise()
    //   .then( (data: any) => {
    //     if (data) {
    //       this.cacheAdvanceSearchIndexedKey = data?.id;
    //       this.cacheAdvanceSearchFields = data?.pageableParam?.searchFields;
    //       this.cacheSearchCombinationType = data?.pageableParam?.searchCombinationType;
    //       this.loadData();
    //     }
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tableColumns){
      this.cacheTableColumns = this.tableColumns;
    }

    if (changes.tableData$){
      this.subscriptions.add(
        this.tableData$?.subscribe( (tableData) => {
          if (tableData){
            this.cacheTableData = tableData;
          }
        })
      );
    }
  }

  loadData() {

    if (this.cacheSearchFields !== null){
      this.pageable.emit(
        {
          first: this.currentPage,
          size: this.pageSize,
          sortBy: this.sortKey,
          sortDirection: this.sortDirectionKey,
          searchFields: this.cacheSearchFields
        }
      );
    }

    else if (this.cacheAdvanceSearchFields?.length > 0) {
      let searchFields = this.cacheAdvanceSearchFields;

      if (this.cacheSearchFields?.length > 0) {
        searchFields = [...this.cacheSearchFields];
      }

      this.pageable.emit(
        {
          first: this.currentPage,
          size: this.pageSize,
          sortBy: this.sortKey,
          sortDirection: this.sortDirectionKey,
          searchCombinationType: this.cacheSearchCombinationType !== null ? this.cacheSearchCombinationType : SearchCombinationTypeEnum.Or,
          searchFields
        }
      );
    }

    else {
      this.pageable.emit(
        {
          first: this.currentPage,
          size: this.pageSize,
          sortBy: this.sortKey,
          sortDirection: this.sortDirectionKey,
        }
      );
    }

  }

  getPage(pageIndex: number) {
    this.currentPage = pageIndex;
    this.pagination = this.settingsService.generatePagination(pageIndex, this.totalPages);
    this.loadData();
  }

  onSearchClear() {
    this.searchKey = null;
    this.currentPage = 0;
    this.cacheSearchFields = null;
    this.loadData();
  }

  filterTable() {
    this.searchKey = this.searchKey.toLowerCase();
    this.currentPage = 0;

    if (this.searchKey){
      this.cacheSearchFields = this.searchFields?.map( (searchField) => {
        let searchFieldData;

        if (searchField?.fieldValues?.length > 0){
          searchFieldData = {
            fieldName: searchField?.fieldName,
            searchType: searchField?.searchType,
            fieldValues: searchField?.fieldValues,
          };
        }else {
          searchFieldData = {
            fieldName: searchField?.fieldName,
            searchType: searchField?.searchType,
            fieldValue: this.searchKey,
          };
        }

        return searchFieldData;
      });
    }else {
      this.cacheSearchFields = null;
    }

    this.loadData();
  }

  sortData(event: Sort) {
    this.sortKey = event.active;
    this.sortDirectionKey = event.direction ?? this.sortDirectionKey;
    this.loadData();
  }

  getPageSize(page: number) {
    this.pageSize = page;
    this.loadData();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;

    return numSelected === this.cacheTableData.data.length;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  tableColumnChange(data: TableColumn[]) {
    this.cacheTableColumns = data;
    this.tableColumnSelection.emit(data);
  }

  tableAdvanceSearch($event: PageableParam) {
    if ($event?.searchFields){
      this.cacheAdvanceSearchFields = $event?.searchFields;
    }
    this.cacheSearchCombinationType = $event?.searchCombinationType;

    // if (this.cacheAdvanceSearchIndexedKey){
    //   /*update indexed record*/
    //     this.dbService.update(IndexedDBTableName.advance_table_search,
    //       {pageableParam: $event, route: window.location.pathname, id: this.cacheAdvanceSearchIndexedKey});
    // }else {
    //   this.dbService.add(IndexedDBTableName.advance_table_search,
    //       {pageableParam: $event, route: window.location.pathname}).toPromise().then( data => {
    //     if (data){
    //       this.cacheAdvanceSearchIndexedKey = data?.id;
    //     }
    //   });
    //
    // }

    this.loadData();
  }

  clearAdvanceSearch() {
    this.cacheAdvanceSearchFields = [];
    this.cacheSearchCombinationType = SearchCombinationTypeEnum.Or;

    // if (this.cacheAdvanceSearchIndexedKey){
    //     this.dbService.deleteByKey(IndexedDBTableName.advance_table_search, this.cacheAdvanceSearchIndexedKey);
    // }

    this.loadData();
  }

  copyTable($event) {
    if ($event){
      if (this.clipboard.copy(document.getElementById('table').innerText)){
        this.notificationService.message('Table Content Copied!');
      }else {
        this.notificationService.errorMessage('Copy Failed!');
      }
    }
  }
}
